import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LearningLiveSession from "./LearningLiveSession";
// import "./SuperStarContent.css";

const EvaluationPostDetails = (props) => {
  const history = useHistory();
  const [event, setEvent] = useState("");

  useEffect(() => {
    let isMounted = true;
    const event_id = props.match.params.id;
    axios
      .get(`/api/star/learning_session/details/${event_id}`)
      .then((res) => {
        if (isMounted) {
          if (res.data.status === 200) {
            setEvent(res.data.event);
          }
        }
      });
  }, [props.match.params.id, history]);

  return (
    <>
      <div className="AS">
        <div className="card card-bg head-line mb-2">
          <div className="text-light d-flex p-2">
            <div className="faTrophy">
              <i className="fas fa-trophy"></i>
            </div>
            <h4 className="text-white d-flex justify-content-center p-2">
              {event.title}
            </h4>
          </div>
        </div>

        <div className="row my-4">
          <div className="col-md-12">
            <div className="card card-bg shadow">
              <div className="card-body">
                <LearningLiveSession event={event}></LearningLiveSession>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EvaluationPostDetails;
